import {
  AGE,
  AGES,
  MARITAL_STATUS,
  PARTNER_NAME,
  TAX_FILING_STATE,
  INCOME,
  EXPENSES,
  CHILDREN,
  CHILDREN_DETAILS,
  DEBTS,
  EMERGENCY_FUND_TARGET_AMOUNT,
  EMERGENCY_FUND_TARGET_YEAR,
  EARMARKED_ACCOUNTS,
} from '../SummaryConstants';

const DICTIONARY = {
  [MARITAL_STATUS]: {
    iterator: [0, 0],
    title: 'Partner',
  },
  [PARTNER_NAME]: {
    iterator: [0, 1],
    title: 'Partner\'s Name',
  },
  [AGES]: {
    iterator: [0, 2],
    title: 'Ages',
  },
  [AGE]: {
    iterator: [0, 2],
    title: 'Age',
  },
  [CHILDREN]: {
    iterator: [0, 3],
    title: 'Children',
  },
  [CHILDREN_DETAILS]: {
    iterator: [0, 4],
    title: 'Children Details',
  },
  [TAX_FILING_STATE]: {
    iterator: [1, 0],
    title: 'Tax Filing State',
  },
  [INCOME]: {
    iterator: [2, 0],
    title: 'Income',
  },
  [EXPENSES]: {
    iterator: [3, 0],
    title: 'Expenses',
  },
  [DEBTS]: {
    iterator: [4, 0],
    title: 'Debts',
  },
  [EMERGENCY_FUND_TARGET_AMOUNT]: {
    iterator: [5],
    title: 'Target Amount',
  },
  [EMERGENCY_FUND_TARGET_YEAR]: {
    iterator: [6],
    title: 'Target Year',
  },
  [EARMARKED_ACCOUNTS]: {
    iterator: [7, 1],
    title: 'Earmarked Accounts',
  },
};
export default DICTIONARY;
